import {
  reassignPayloadSchema,
  ReassignPayloadSchema,
  useRFS,
  useRFSReassign,
} from "@/api/rfs";
import { UserData, useUsers } from "@/api/user";
import { FieldCombobox } from "@/components/form/field-combobox";
import { FormContainer } from "@/components/form/form-container";
import { SubmitButton } from "@/components/ui/button";
import { ROLE } from "@/utils/constant";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function RFSReassignForm({ id }: { id: string }) {
  const [userSearch, setUserSearch] = useState("");
  const { data: rfs } = useRFS({ id });
  const form = useForm<ReassignPayloadSchema>({
    resolver: zodResolver(reassignPayloadSchema),
    values: {
      picLinknet: {
        id: rfs?.picLinknet.id ?? "",
      },
    },
  });
  const { data: users } = useUsers({
    role: ROLE.VALIDATOR_DOCUMENT_OFFICER.toUpperCase(),
  });
  const { mutate, isPending } = useRFSReassign();
  const navigate = useNavigate();

  const user = form.getValues("picLinknet") as UserData;

  const handleSubmit = (values: ReassignPayloadSchema) => {
    mutate(
      { id: id, data: values },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              text: "RFS has been reassigned",
            })
            .then(() => navigate("/rfs/rfs"));
        },
        onError: (error) => {
          swalError.fire({
            text: error.message,
          });
        },
      },
    );
  };

  return (
    <FormContainer form={form} onSubmit={handleSubmit}>
      <FieldCombobox
        name="picLinknet.id"
        label="Reassign"
        search={userSearch}
        setSearch={setUserSearch}
        options={(users?.content ?? (user && [user]) ?? [])?.map((user) => ({
          value: user.id,
          label: user.username,
        }))}
        hasRequiredAsterisk
      />
      <SubmitButton loading={isPending} className="ml-auto" />
    </FormContainer>
  );
}
